import { h } from 'preact';
import { t } from '../../i18n.js';

export default function SearchBar({ value, onInput, onSubmit, placeholder }) {
  return (
    <form class="header-search" onSubmit={(e) => { e.preventDefault(); onSubmit && onSubmit(); }} style="max-width:none">
      <svg viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
      </svg>
      <input
        type="text"
        placeholder={placeholder || t('common.search')}
        value={value}
        onInput={(e) => onInput(e.target.value)}
      />
    </form>
  );
}
